import { type Html, html, rune, View } from 'rune-ts';
import klass from './YoutubeSection.module.scss';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { htmlIf } from '@services/MarppleShop/shared/util';

export class YoutubeSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const text = {
      desc: is_mobile
        ? html.preventEscape(`유튜브 채널이 있다면<br />
          내가 만든 굿즈를 노출시킬 수 있어요!<br />
          동영상, Shorts, 실시간 스트림까지<br />
          어디에나 상품을 태그하고 공개해 보세요`)
        : html.preventEscape(`유튜브 채널이 있다면 내가 만든 굿즈를 노출시킬 수 있어요!<br />
          동영상, Shorts, 실시간 스트림까지 <br />
          어디에나 상품을 태그하고 공개해 보세요.`),
      title: '마플샵 X 유튜브 쇼핑',
    };

    return html`
      <section class="${klass.container}">
        <div class="${klass.content_wrapper}">
          ${htmlIf(
            html`<img
              src="${getResizedUrl({
                url: '//s3.marpple.co/files/u_4648126/2025/1/original/def472ecd517844f85017d59eb0be9e715256b4c11.webp',
                width: 160 * 2,
                quality: 85,
                format: 'webp',
              })}"
              class="${klass.character_img}"
              alt="캐릭터 이미지"
            />`,
            !is_mobile,
          )}
          <div class="${klass.title_wrapper}">
            <div class="${klass.title}">
              <div class="${staticFont('bebas_20_bold')}">CHAPTER 2.</div>
              <div class="${font('48_bold', '28_bold')}">${text.title}</div>
            </div>
            <div class="${font('20_medium', '14_medium')}">${text.desc}</div>
          </div>
        </div>
        <div class="${klass.video_wrapper}">
          <video
            autoplay=""
            loop=""
            muted=""
            playsinline=""
            class="${klass.motion_video}"
            src="//s3.marpple.co/files/u_4648126/2025/6/original/f7b5b4a5bdfa2d8104ca84654bb1971f05c937431.mp4"
          ></video>
        </div>
      </section>
    `;
  }
}
